import React from 'react';
import { Facebook, MessageCircle, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';

const FacebookSection = () => {
  return (
    <section className="py-12 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-[#eedec0] rounded-none p-8 md:p-16 text-zinc-900 overflow-hidden relative shadow-2xl"
        >
          {/* Decorative icons in background */}
          <Facebook className="absolute -right-10 -bottom-10 w-64 h-64 text-black/5 rotate-12" />
          
          <div className="relative z-10 max-w-3xl">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="inline-flex items-center gap-2 text-sm font-bold mb-6">
                <Facebook size={16} />
                Følg os på Facebook
              </div>
              <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-6 leading-tight text-black">
                Se aktuelle kampagner og tilbud på Facebook
              </h2>
              <p className="text-xl text-zinc-700 mb-10 leading-relaxed">
                Vi bruger Facebook som vores primære kanal til hurtige tilbud, nye varer og dagsaktuelle priser. 
                Gå ikke glip af den næste kampagne!
              </p>
              
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://www.facebook.com/paapladsen"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-black text-white px-8 py-4 rounded-none font-bold hover:bg-zinc-800 transition-all shadow-lg"
                >
                  Gå til Facebookside
                  <ExternalLink size={18} />
                </a>
                <a
                  href="https://m.me/paapladsen"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-transparent border border-black text-zinc-900 px-8 py-4 rounded-none font-bold transition-all shadow-lg"
                >
                  <MessageCircle size={20} />
                  Messenger
                </a>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FacebookSection;
